import { figures } from "@/mocks/blackdata";

const levelMap: Record<string, string> = {
  "S 级热度": "bg-primary-600 text-background-50",
  "A 级争议": "bg-accent-500 text-background-50",
  "B 级争议": "bg-background-200 text-foreground-800",
};

export default function FigureArchive() {
  return (
    <section id="figure" className="max-w-[1400px] mx-auto px-3 md:px-6 pt-10 md:pt-14 scroll-mt-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 pb-5">
        <div>
          <span className="inline-flex items-center gap-1 rounded bg-foreground-800 text-background-50 px-2 py-0.5 text-[11px] whitespace-nowrap">
            <i className="ri-folder-user-fill w-3.5 h-3.5 flex items-center justify-center"></i>
            人物档案专区
          </span>
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mt-2">按人物翻车榜 · 逐一建档</h2>
          <p className="text-[13px] md:text-sm text-foreground-600 mt-1">每个账号单独一页思路整理：争议点、实锤条数、事件时间线一次看全。</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {figures.map((f) => (
          <article key={f.name} className="group flex gap-3 md:gap-4 bg-background-100 border border-background-200 rounded-lg p-3 md:p-4 hover:border-background-300 transition-colors">
            <div className="relative w-20 h-20 md:w-24 md:h-24 shrink-0 rounded-lg overflow-hidden bg-foreground-900">
              <img src={f.image} alt={`${f.name}人物档案`} className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="flex flex-col min-w-0 gap-1.5 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-heading text-base text-foreground-950">{f.name}</h3>
                <span className={`rounded px-1.5 py-0.5 text-[10px] whitespace-nowrap ${levelMap[f.level]}`}>{f.level}</span>
              </div>
              <p className="text-[11px] text-foreground-400">{f.handle}</p>
              <p className="text-[12px] text-foreground-600 leading-relaxed line-clamp-2">{f.desc}</p>
              <div className="flex flex-wrap gap-1.5 mt-auto pt-1">
                {f.tags.slice(0, 3).map((t) => (
                  <span key={t} className="rounded bg-background-200 px-1.5 py-0.5 text-[10px] text-foreground-600 whitespace-nowrap">{t}</span>
                ))}
              </div>
              <a href="#timeline" className="inline-flex items-center gap-1 text-[12px] text-primary-700 font-medium whitespace-nowrap">
                查看档案与时间线<i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}